// extracted by mini-css-extract-plugin
module.exports = {"RootMenu":"dropdown-menu_RootMenu__EU5Kx","Menu":"dropdown-menu_Menu__RfrUL","MenuItem":"dropdown-menu_MenuItem__ePKBg"};